import React, { FC } from 'react'

/** packages */
import clsx from 'clsx'

import styles from './_.module.css'

type Link = {
  path: string
  title: string
  dataId?: string
}
interface NavlinkProps {
  link: Link[]
  active: string
  changeActive: (page: string) => void
  className: string
  activeClassName: string
}

const NavLink: FC<NavlinkProps> = ({
  link,
  active,
  changeActive,
  className,
  activeClassName,
}) => {
  return (
    <div className={styles.navLinkWrap}>
      {link.map((item: Link, index: number) => {
        return (
          <button
            onClick={() => changeActive(item.path)}
            className={clsx(className, styles.navButton, {
              [activeClassName]: active === item.path,
            })}
            key={index}
            data-id={item.dataId}
          >
            {item.title}
          </button>
        )
      })}
    </div>
  )
}

export default NavLink
